import { render } from "./ReportDashboard.vue?vue&type=template&id=a309dd10&scoped=true"
import script from "./ReportDashboard.vue?vue&type=script&lang=js"
export * from "./ReportDashboard.vue?vue&type=script&lang=js"

import "./ReportDashboard.vue?vue&type=style&index=0&id=a309dd10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a309dd10"]])

export default __exports__